import Avatar from '@mui/material/Avatar'
import Badge from '@mui/material/Badge'
import Stack from '@mui/material/Stack'
import PropTypes from 'prop-types'
import React from 'react'
import { iconsItems } from '../assets/icons'
import { getMediaUrl, getNames } from '../helpers'
import { useDefaultComponentTools } from '../hooks/useDefaultComponentTools'

function AppIconDouble({ name, double, size, positionTop, sxCustom }) {
	const letMove = double && positionTop
	const { theme } = useDefaultComponentTools()
	let firstPart = name.includes('/') ? getNames(name)[0].toLowerCase() : getNames(name)
	let secondPart = name.includes('/') ? getNames(name)[1].toLowerCase() : getNames(name)
	const mediaUrl = getMediaUrl(true)
	return (
		<Stack
			direction='row'
			sx={{position: 'relative', width: double ? size * 1.5 : size, ...sxCustom }}
			spacing={2}
		>
			<Badge
				sx={{ position: double && letMove && 'absolute', top: letMove && positionTop }}
				overlap='circular'
				anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
				badgeContent={double && name.includes('/') &&
					<Avatar
						sx={{
							border: `2px solid ${theme.palette.second}`,
							height: size, width: size
						}}
						alt={secondPart}
						src={mediaUrl + iconsItems[secondPart]} />
				}
			>
				<Avatar
					sx={{ height: size, width: size }}
					alt={firstPart}
					src={mediaUrl + iconsItems[firstPart]} />
			</Badge>
		</Stack >
	)
}

AppIconDouble.propTypes = {
	double: PropTypes.bool,
	name: PropTypes.string,
	positionTop: PropTypes.string,
	size: PropTypes.number,
	sxCustom: PropTypes.object

}

export default AppIconDouble

